/**
 * Default font used in repoV2
 */
export const DEFAULT_FONT = {
    title: "Montserrat",
    url: "https://fonts.googleapis.com/css2?family=Montserrat&display=swap",
};
